import $axios from '~/plugins/axios';

import { Api, CampaignType } from '~/api';
import { buildModule } from '../utils';
import { Dict, createDict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedCampaignTypes: {} as Dict<CampaignType>,
		campaignTypes: [] as CampaignType[],
		loading: false,
	})
	.withGetters({
		byId: state => (campaignTypeId: CampaignType['id']): CampaignType | null => (
			state.storedCampaignTypes[campaignTypeId] ?? null
		),
		page: state => state.campaignTypes,
		loading: state => state.loading,
	})
	.withMutations({
		SET_STORED_CAMPAIGN_TYPES (state, campaignTypes: CampaignType[]) {
			state.storedCampaignTypes = {
				...state.storedCampaignTypes,
				...createDict(campaignTypes, (type) => type.id),
			};
		},
		SET_CAMPAIGN_TYPES (state, campaignTypeIds: CampaignType['id'][]) {
			state.campaignTypes = campaignTypeIds.map(id => state.storedCampaignTypes[id]);
		},
		SET_LOADING (state, loading: boolean) {
			state.loading = loading;
		},
	})
	.withActions({
		async get ({ commit }) {
			commit('SET_LOADING', true);
			const { data } = await api.get('/campaign-type');
			commit('SET_LOADING', false);

			const campaignTypes = data.payload;
			const campaignTypeIds = campaignTypes.map(type => type.id);

			commit('SET_STORED_CAMPAIGN_TYPES', campaignTypes);
			commit('SET_CAMPAIGN_TYPES', campaignTypeIds);
		},
	});
